module.exports = __webpack_public_path__ + "static/media/1f46a.5c0828b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/emoji/1f46a.svg
// module id = 645
// module chunks = 1